import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { forumdetails } from '../models/forum';
import { UseraccessserviceService } from '../services/useraccessservice.service'
// import  *  as  data  from  './jsonobject.json';

@Injectable({
  providedIn: 'root',
})
export class ForumService {
  readonly rootURL = environment.ImpataAppAPIRoot;
  readonly userTokenLocalStorageKey = environment.userTokenStore;
  readonly currentUserToken: string;
  

  questions: forumdetails[];
  lastId: number;
  currentuser: string;
  comments: forumdetails[];
  req_headers = new HttpHeaders({
    'content-type': 'application/json',
    accept: 'application/json',
  });
  constructor(
    private useraccessservice: UseraccessserviceService,
    private httpClient: HttpClient
  ) {
    
    // this.currentuser= useraccessservice.
  }

  addquestion(question: forumdetails) {
    //UI add
    // console.log("question is" + question)
    // // if (!question.id) {
    // //   question.id = ++this.lastId;
    // // }
    // // this.questions.push(question);
    // // return this;

    //Server add
    let data = JSON.stringify(question);
    console.log('aboy');
    var response = this.httpClient.post(
      this.rootURL + 'forum/addiscussion?data=' + data,
      data,
      { headers: this.req_headers }
    );
    console.log('response is ' + response[0]);

    // debugger;
    return response;
  }

  deletequestionById(id: number) {
    //UI delete
    // this.questions = this.questions
    //   .filter(question => question.id !== id);
    // return this;

    //Server Delete

    return this.httpClient.delete(
      this.rootURL + 'forum/deletediscussion/?id=' + id,
      { headers: this.req_headers }
    );
  }
  getAllComments(): Observable<forumdetails[]> {
    //const subcomments = this.comments.filter(function (comment) { return (comment.parentid == 0); });
    // return subcomments;
    var response = this.httpClient.get<forumdetails[]>(
      this.rootURL + 'forum/getdiscussions',
      { headers: this.req_headers }
    );
    return response;
  }

  getCommentsById(
    parentcommentid: number,
    moduleid: number,
    commentid: number,
    previousId: number = 0,
  ): Observable<forumdetails[]> {
    //UI get comment
    // const subcomments = this.comments.filter(function (comment) { return ((comment.id == parentcommentid || comment.parentid == parentcommentid) && comment.moduleid == moduleid); });
    // this.questions = subcomments;
    // return subcomments;

    //Server get comment

    let params: HttpParams = new HttpParams()
      .set('moduleid', moduleid.toString())
      .set('parentcommentid', parentcommentid.toString())
      .set('commentid', commentid.toString());//Create new HttpParams
      if (previousId > 0)
        params = params.set('previousCommentId', previousId);
      
    var response = this.httpClient.get<forumdetails[]>(
      this.rootURL + `forum/getdiscussions`,
      { headers: this.req_headers, params: params }
    );
    //?moduleid=${moduleid}=&parentcommentid=${parentcommentid}`
    console.log(response);
    return response;
  }

  isModuleUser(userId: number, moduleId: number) {
    // let params: HttpParams = new HttpParams()
    //   .set('userId', userId)
    //   .set('moduleid', moduleid); //Create new HttpParams

    var response = this.httpClient.get<any>(
      this.rootURL + `forum/ismoduleadmin/?userId=${userId}&moduleId=${moduleId}`,
      { headers: this.req_headers }
    );
    return response;
  }
}
